<template>
  <div>
    <div class="box" v-for="(item, index) in list" :key="index">
      <div class="title">
        <div class="methodTitle">
          <h3 class="bq">代理名称</h3>
          <h3>{{ item.agentName ? item.agentName : '未填写' }}</h3>
        </div>
        <div class="methodSlidebt">
          <ul>
            <li>
              <h3>SIM卡</h3>
              <p>{{ item.cardQuantity ? item.cardQuantity : '0' }}</p>
            </li>
            <li>
              <h3>手机号</h3>
              <p>{{ item.mobile ? item.mobile : '未填写' }}</p>
            </li>
            <li>
              <h3>注册时间</h3>
              <p>{{ item.createTime }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    list: {
      type: Array
    }
  },
  data () {
    return {
    }
  },
  watch: {},
  computed: {},
  methods: {
    boxBtn (e) {
      this.$router.push({ name: 'Recharge', params: { iccid: e } })
    }
  },
  beforeCreate () {},
  created () {},
  mounted () {}
}
</script>

<style scoped lang='less'>
  [class*=van-hairline]::after {
    border: none;
  }
  .box {
    width: 690px;
    height: 280px;
    background-color: #fff;
    margin: 0 auto 20px;
    box-shadow: 0 4px 10px 5px rgba(15,27,115,8%);
    border-radius: 15px;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 40px 40px 20px;
    .title {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .methodTitle {
        display: flex;
        justify-content: space-between;
        h3 {
          font-size: 30px;
          color: #272729;
          line-height: 20px;
          font-weight: 400;
        }
        .bq {
          width: 130px;
          text-align: end;
          color: #9D9DA3;
        }
      }
      .methodSlidebt {
        ul {
          display: flex;
          justify-content: space-between;
          height: 70px;
          li {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            h3 {
              line-height: 18px;
              font-size: 25px;
              color: #9D9DA3;
            }
            p {
              line-height: 20px;
              font-size: 25px;
              color: #272729;
            }
          }
        }
      }
    }
    .btn {
      flex: 1;
      text-align: center;
      padding-left: 45px;
      .van-button {
        width: 100px;
      }
    }
  }
  .box:after {
    display: block;
    content: "";
    width: 32px;
    height: 32px;
    background: url(../assets/yans-1.png) no-repeat;
    background-size: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
</style>
